<div class="body-container">
  @if (!hideNavbar && (accountService.currentUser$ | async)) {
    <app-navbar class="navbar navbar-sm navbar-fixed-xl navbar-expand-lg navbar-white" />
  }
  @if (!hideSidebar && (accountService.currentUser$ | async)) {
    <app-sidebar
      [NgAceSidebar]="{ dismiss: true, swipe: true, pullup: true }"
      #sidebar="NgAceSidebar"
      NgAceSidebar
      id="sidebar"
      class="sidebar sidebar-fixed sidebar-hover sidebar-h sidebar-white sidebar-top has-open sidebar-backdrop" />
  }

  <div class="main-container bgc-white">
    <div role="main" class="main-content bgc-white">
      <div class="page-content px-md-4 px-xl-5">
        <router-outlet (activate)="setCurrentComponent($event)" />
        <div class="footer">
          @if (footerImage) {
            <img [src]="footerImage" alt="" class="footer-image" />
          }
        </div>
      </div>
    </div>
  </div>
</div>
